import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, renderSlot as _renderSlot, normalizeClass as _normalizeClass, Teleport as _Teleport, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "modal-content" }
const _hoisted_2 = { class: "modal-card" }
const _hoisted_3 = { class: "modal-card-head" }
const _hoisted_4 = { class: "inner-content" }

import type { PropType } from 'vue'
import { ref, watchEffect, onUnmounted } from 'vue'

type ModalSize = undefined | 'small' | 'medium' | 'large' | 'big'
type ModalAction = undefined | 'center' | 'right'


export default /*@__PURE__*/_defineComponent({
  __name: 'VModal',
  props: {
  title: {
    type: String,
    required: false,
  },
  size: {
    type: String as PropType<ModalSize>,
    default: undefined,
    validator: (value: ModalAction) => {
      // The value must match one of these strings
      if (
        [undefined, 'small', 'medium', 'large', 'big'].indexOf(value) === -1
      ) {
        console.warn(
          `V-Modal: invalid "${value}" size. Should be small, medium, large, big or undefined`
        )
        return false
      }

      return true
    },
  },
  actions: {
    type: String as PropType<ModalAction>,
    default: undefined,
    validator: (value: ModalAction) => {
      // The value must match one of these strings
      if ([undefined, 'center', 'right'].indexOf(value) === -1) {
        console.warn(
          `V-Modal: invalid "${value}" actions. Should be center, right or undefined`
        )
        return false
      }

      return true
    },
  },
  open: {
    type: Boolean,
    default: false,
  },
  rounded: {
    type: Boolean,
    default: false,
  },
  noscroll: {
    type: Boolean,
    default: false,
  },
  noclose: {
    type: Boolean,
    default: false,
  },
  tabs: {
    type: Boolean,
    default: false,
  },
},
  emits: ['close'],
  setup(__props, { emit: __emit }) {

const props = __props
const emit = __emit

const wasOpen = ref(false)

const checkScroll = () => {
  if (props.noscroll && props.open) {
    document.documentElement.classList.add('no-scroll')
    wasOpen.value = true
  } else if (wasOpen.value && props.noscroll && !props.open) {
    document.documentElement.classList.remove('no-scroll')
    wasOpen.value = false
  }
}

watchEffect(checkScroll)
onUnmounted(() => {
  document.documentElement.classList.remove('no-scroll')
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_Teleport, { to: "body" }, [
    _createElementVNode("div", {
      class: _normalizeClass([[__props.open && 'is-active', __props.size && `is-${__props.size}`], "modal v-modal"])
    }, [
      _createElementVNode("div", {
        class: "modal-background v-modal-close",
        onClick: _cache[0] || (_cache[0] = () => __props.noclose === false && emit('close'))
      }),
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("header", _hoisted_3, [
            _createElementVNode("h3", null, _toDisplayString(__props.title), 1),
            _createElementVNode("button", {
              class: "v-modal-close ml-auto",
              "aria-label": "close",
              onClick: _cache[1] || (_cache[1] = ($event: any) => (emit('close')))
            }, [...(_cache[3] || (_cache[3] = [
              _createElementVNode("i", {
                "aria-hidden": "true",
                class: "iconify",
                "data-icon": "feather:x"
              }, null, -1)
            ]))])
          ]),
          _createElementVNode("div", {
            class: _normalizeClass(["modal-card-body", [props.tabs && 'has-tabs']])
          }, [
            _createElementVNode("div", _hoisted_4, [
              _renderSlot(_ctx.$slots, "content")
            ])
          ], 2),
          _createElementVNode("div", {
            class: _normalizeClass(["modal-card-foot", [
              __props.actions === 'center' && 'is-centered',
              __props.actions === 'right' && 'is-end',
            ]])
          }, [
            _renderSlot(_ctx.$slots, "cancel", {}, () => [
              _createElementVNode("a", {
                class: _normalizeClass(["button VButton v-modal-close", [__props.rounded && 'is-rounded']]),
                onClick: _cache[2] || (_cache[2] = ($event: any) => (emit('close')))
              }, " Cancel ", 2)
            ]),
            _renderSlot(_ctx.$slots, "action")
          ], 2)
        ])
      ])
    ], 2)
  ]))
}
}

})